import { FC } from 'react';

import { Icon, Link } from '@dbt-labs/sourdough';
import { RyeconLineage } from '@dbt-labs/sourdough';

import LineageSvg from '@/assets/ad-unit-lineage.svg?react';
import LinesSvg from '@/assets/ad-unit-lines.svg?react';
import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
export const LineageAdUnit: FC = () => {
  const { accountId } = useDbtCloudProject();

  const projectLineageLinkGenerator = useLinkToExplorer('projectLineage');
  const lineageLink = projectLineageLinkGenerator({
    ...useUrlProjectParams(),
  });
  const multiProjectLinkGenerator = useLinkToExplorer('multiProject');
  const multiProjectLink = multiProjectLinkGenerator({
    accountId,
    view: 'lineage',
  });

  return (
    <div className="relative flex w-full items-center space-x-10 overflow-hidden bg-gradient-to-r from-gray-800 to-gray-600 px-7 py-5 align-middle">
      <LineageSvg className="flex" />
      <div>
        <div className="text-md text-fgWhite">Visualize how your data flows</div>
        <div className="my-2 text-sm font-normal text-fgWhite">
          Dive into lineage to see how the data lands inside of your warehouse. See
          where it comes from and where it serves your team.
        </div>
        <div className="mt-6 flex items-center">
          <Link to={lineageLink} isInternal buttonStyleType="secondary">
            <Icon ryecon={RyeconLineage} />
            View lineage
          </Link>
          <Link
            to={multiProjectLink}
            isInternal
            className="ml-4 h-full text-sm text-fgWhite no-underline hover:text-fgWhite hover:underline"
          >
            Account lineage
          </Link>
        </div>
      </div>
      <LinesSvg className="absolute right-0 flex h-[150px] text-fgWhite" />
    </div>
  );
};
